export type FormaCartao = 'numero' | 'barras' | 'rosca' | 'tabela';

/**
 * Formato do cartão e intenção da consulta são **uma escolha só**.
 *
 * 🔴 Medido: o editor oferecia os dois em campos separados, e a pessoa montava
 * uma combinação que não existe — "mostrar como número" com uma consulta que
 * agrupa. O servidor recusava com 400, depois de todo o trabalho feito.
 *
 * Validar melhor seria remendo. O certo é **não deixar o estado inválido
 * existir**: quem escolhe o formato define a intenção, e ninguém precisa saber
 * que existe uma palavra chamada "intenção".
 *
 * ⚠️ Espelha `formaCombina`/`formaSugerida` de
 * `packages/domain/src/painel/painel.ts`, que é a autoridade — o servidor
 * valida por lá. `cartoes.test.ts` compara as duas e falha se divergirem.
 */
export const INTENCAO_DA_FORMA: Readonly<Record<FormaCartao, string>> = {
  numero: 'contar',
  barras: 'agrupar',
  rosca: 'agrupar',
  tabela: 'listar',
};

export const intencaoDaForma = (f: FormaCartao): string => INTENCAO_DA_FORMA[f];

/** O formato natural para uma consulta que já existe. */
export function formaSugerida(intencao: string): FormaCartao {
  if (intencao === 'contar') return 'numero';
  if (intencao === 'agrupar') return 'barras';
  return 'tabela';
}

/** Formatos que precisam saber por qual campo agrupar. */
export const AGRUPA = (f: FormaCartao): boolean => f === 'barras' || f === 'rosca';

export const FORMAS: readonly { readonly valor: FormaCartao; readonly rotulo: string }[] = [
  { valor: 'numero', rotulo: 'Número grande — uma contagem' },
  { valor: 'barras', rotulo: 'Barras — quebra por campo' },
  { valor: 'rosca', rotulo: 'Rosca — quebra por campo' },
  { valor: 'tabela', rotulo: 'Tabela — lista de máquinas' },
];
